<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="yearForm" class="col-12">
            <input matInput [formControlName]="'id'" hidden>
            <input matInput [formControlName]="'definitionId'" hidden>

            <div class="row">
                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>Year</mat-label>
                    <mat-select formControlName="year" required>
                        <mat-option *ngFor="let item of year" [value]="item.C_Year_ID">{{item.FiscalYear}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="yearForm.get('year')?.hasError('required')">
                        Year is required.
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>Quantity</mat-label>
                    <input matInput placeholder="Quantity" type="number" formControlName="quantity" required>
                    <mat-error *ngIf="yearForm.get('quantity')?.hasError('required')">
                        Quantity is required.
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>Computation Period</mat-label>
                    <mat-select formControlName="computationPeriod" required>
                        <mat-option *ngFor="let period of computationPeriod" [value]="period.Value">{{period.Name}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="yearForm.get('computationPeriod')?.hasError('required')">
                        Computation period is required.
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>Net Days</mat-label>
                    <input matInput placeholder="Net Days" type="number" formControlName="netDays" required>
                    <mat-error *ngIf="yearForm.get('netDays')?.hasError('required')">
                        Net days are required.
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field class="col-6" appearance="outline">
                    <mat-label>Start Date:</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="date">
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle class="mat-mdc-icon-button" matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="yearForm.get('date')?.hasError('required')">
                        Date is required.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{ data.cancelText }}</button>
        <button mat-button class="btn btn-success yes-button" [disabled]="yearForm.invalid" (click)="save()"
            *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial>{{ data.confirmText }}</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>